module.exports = __webpack_public_path__ + "img/psql.6961deaf.png";